"use client";

import Image from "next/image";
import { ComponentProps } from "react";
import {
  crossDomainImageLoader,
  unifiedTemplatesImageLoader,
} from "src/utils/images";
import { isUnifiedTemplatesAPIPreviewImage } from "src/utils/isUnifiedTemplatesImage";

type Props = ComponentProps<typeof Image>;

export const CrossDomainImage = (props: Props) => {
  const isUnifiedTemplatesImage =
    typeof props.src === "string" &&
    isUnifiedTemplatesAPIPreviewImage(props.src);

  return (
    <Image
      {...props}
      loader={
        isUnifiedTemplatesImage
          ? unifiedTemplatesImageLoader
          : crossDomainImageLoader
      }
    />
  );
};
